import moment from 'moment';
import { hasValue } from 'swipeclock-frontend';

// Makes dates into format: 2021-01-26
export const formatDateForURL = (date = moment()) =>
  moment(date ? date : moment()).format('YYYY-MM-DD');

// Make dates into format: 1/26/2021
export const formatDateForPayrollReview = (date = moment()) =>
  moment(date ? date : moment()).format('M/D/YYYY');

export const formatDateForWizard = (date = moment()) =>
  moment(date ? date : moment()).format('M/D/YYYY');

export const makeISODateFromWizardDate = (date = moment()) =>
  moment(date ? date : moment()).format('YYYY-MM-DDT00:00:00');

export const formatDateforAccruals = (date = moment()) =>
  moment(date ? date : moment()).format('MM/DD');

export const formatApiDateforAccruals = (date) => {
  if (!hasValue(date)) {
    return '';
  }
  return moment.utc(date).format('MM/DD');
};

export const formatDateToMonthAndDay = (date = moment()) =>
  moment(date ? date : moment()).format('MM/DD');

export const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

export const convertPascalCaseToSentence = (str) =>
  str
    ?.replace(/([A-Z]+)/g, '$1')
    .replace(/([A-Z][a-z])/g, ' $1')
    .toLowerCase()
    .trim();

export const formatPolicyNameToURLFriendly = (str) => {
  return encodeURIComponent(str).replace('%20', '-').toLowerCase().trim();
};

export const numberToRoundedString = (number, precision = 2) => {
  if (parseInt(number, 10) === number) {
    return number.toString();
  }
  const digits = precision;
  const multiplier = Math.pow(10, digits);
  const newNumber = parseFloat((number * multiplier).toFixed(11));
  return (Math.round(newNumber) / multiplier).toFixed(digits);
};

export const formatPluralInterval = (interval, lengthOfInterval) => {
  const isPlural =
    hasValue(lengthOfInterval) && lengthOfInterval !== Math.abs(1);
  return isPlural
    ? `${lengthOfInterval} ${interval}s`
    : `${lengthOfInterval} ${interval}`;
};

export const formatFormikOnChangeStringToNumber = (
  event,
  field,
  fieldValueSetter
) => {
  const stringToNumber = Number(event.target.value);

  return fieldValueSetter(field, stringToNumber);
};

export const formatFormikStringToBoolean = (event, field, fieldValueSetter) => {
  const value = event?.target?.value;
  const stringToBoolean = value.toLowerCase() === 'true';
  return fieldValueSetter(field, stringToBoolean);
};

export function formatNegativeNumber(value) {
  // returns a negative int -1
  let input = value.replace(/\D/g, '');
  let size = input.length;

  if (size > 0) {
    input = `-${input}`;
  }

  if (size > 3) {
    input = input.slice(0, 4); // account for '-'
  }

  return input === '-0' ? '' : input;
}

export function formatPositiveNumber(value, allowForZero = true) {
  let input = value.replace(/\D/g, '');
  let size = input.length;

  if (size > 3) {
    input = input.slice(0, 3);
  }

  if (allowForZero) {
    return +input < 0 ? '' : input;
  }
  return +input <= 0 ? '' : input;
}

export function formatInputForDateFF(value) {
  if (!value) {
    return '';
  }
  const getDateDigits = (v) => v.toString().replace(/\D/g, '').substring(0, 8);
  // returns MM/DD/YYYY
  let input = value.replace(/\D/g, '');
  let size = input.length;
  console.log('input', input, 'size', size, 'Digits', getDateDigits(value));

  // 05/2/1920
  const date = getDateDigits(value);
  const day = date.substring(0, 2);
  const month = date.substring(2, 4);
  const year = date.substring(4, 8);
  console.log('Day', day, 'month', month, 'year', year);

  let formattedDate = '';
  if (date.length > 4) {
    formattedDate = `${day}/${month}/${year}`;
  } else if (date.length > 2) {
    formattedDate = `${day}/${month}`;
  } else if (date.length > 0) {
    formattedDate = day;
  }

  return formattedDate;
}

export function formatInputForDate(value) {
  if (!value) {
    return '';
  }
  let input = value.replace(/\D/g, '');
  let size = input.length;

  const foo =
    {
      0: `${input.slice(0, 2)}`,
      1: `${input.slice(0, 2)}`,
      2: `${input.slice(0, 2)}/${input.slice(2, size)}`,
      3: `${input.slice(0, 2)}/${input.slice(2, size)}`,
      4: `${input.slice(0, 2)}/${input.slice(2, size)}/`,
    }[size] ?? `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;

  return foo;
}

export function convertToRoman(num) {
  let numberToConvert = num;
  let roman = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };
  let str = '';

  for (let i of Object.keys(roman)) {
    let q = Math.floor(numberToConvert / roman[i]);
    numberToConvert -= q * roman[i];
    str += i.repeat(q);
  }

  return str;
}
